module.exports = __webpack_public_path__ + "static/3-a7adff554d240e7e26a164ab0a8183bc.jpg";